<template>
	<swiper :watch-slides-progress="true" :slides-per-view="1" :loop="true" :modules="modules"
		:autoplay="autoplayOptions">
		<swiper-slide v-for="(slide, index) in slides" :key="index" @click="handleSlideClick(index)">
			<img :src="slide.image" />
		</swiper-slide>
	</swiper>
</template>
<script setup>
	import {
		ref
	} from 'vue'
	import {
		Swiper,
		SwiperSlide
	} from 'swiper/vue'
	import {
		Pagination,
		Autoplay
	} from 'swiper/modules';
	import 'swiper/css'
	import 'swiper/css/autoplay'
	import './style.css';

	const modules = [Pagination, Autoplay]
	const swiperInstance = ref(null);
	const onSwiper = (swiper) => {
		swiperInstance.value = swiper
		// 初始化后强制更新循环
	}
	// 自动轮播配置
	const autoplayOptions = ref({
		delay: 5000, // 3秒切换一次
		pauseOnMouseEnter: true, // 鼠标悬停时暂停
	})

	const slides = ref([{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/1.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/3.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/4.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/5.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/6.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/7.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/8.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/9.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/1.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/10.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/11.png',
		},{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/13.png',
		}
	])

	const onProgress = (swiper, progress) => {
		for (let i = 0; i < swiper.slides.length; i++) {
			const slideEl = swiper.slides[i]
			const slideProgress = swiper.slides[i].progress
			let modify = 1

			if (Math.abs(slideProgress) > 1) {
				modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
			}

			const translate = slideProgress * modify * 160 + 'px'
			const scale = 1 - Math.abs(slideProgress) / 5
			const zIndex = 999 - Math.abs(Math.round(10 * slideProgress))

			slideEl.style.transform = `translateX(${translate}) scale(${scale})`
			slideEl.style.zIndex = zIndex
			slideEl.style.opacity = 1

			if (Math.abs(slideProgress) > 3) {
				slideEl.style.opacity = 0
			}
		}
	}
	// 修改onSlideChange方法
	const onSlideChange = (swiper) => {}
	const onSetTransition = (swiper, transition) => {
		for (let i = 0; i < swiper.slides.length; i++) {
			const slideEl = swiper.slides[i]
			slideEl.style.transition = `${transition}ms`
		}
	}
	const handleSlideClick = (index) => {
		if (swiperInstance.value) {
			swiperInstance.value.slideToLoop(index, 500);
		}
	};
</script>

<style scoped>
	.swiper {
		width: 60vw;
		height: 80vh;
		margin-left: 0;
		margin-right: 0;
	}

	.swiper-slide {
		width: 520px;
		height: 508px;
		background: #fff;
		box-shadow: 0 8px 30px #ddd;
	}

	.swiper-slide img {
		width: 60vw;
	}

	.swiper-slide p {
		line-height: 98px;
		padding-top: 0;
		text-align: center;
		color: #636363;
		font-size: 1.1em;
		margin: 0;
	}
</style>